import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'edex-register-choose',
  templateUrl: './register-choose.component.html',
  styleUrls: ['./register-choose.component.scss']
})
export class RegisterChooseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
